import React from 'react';
import {useTheme} from '@mui/material';
import type {TranslationKey} from 'localization/context/types';
import {useLocalization} from 'localization';
import {Layout, Spacer, Text} from 'components';

type Props = {
  titleKey: TranslationKey;
  errorCause?: string;
};

export const ErrorMessage: React.FC<Props> = ({
  titleKey,
  errorCause: errorCause,
}) => {
  const {t} = useLocalization();
  const {colors} = useTheme();

  return (
    <Layout
      py={2}
      px={4}
      borderRadius={2}
      adjustCenter
      sx={{backgroundColor: colors.enhancedLightBeige}}>
      <Text variant="body1" kind="error">
        {t(titleKey)}
      </Text>
      {errorCause ? (
        <>
          <Spacer size={1} />
          <Text variant="body2" kind="error">
            {errorCause}
          </Text>
        </>
      ) : null}
    </Layout>
  );
};
